import { Filters } from "types";
import { useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import { getSelectedQueryModal } from "redux/SingleDataset/selectors";
import { isCustomMetadata } from "helpers/utility/customMetadataHelpers";

import FileQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/FileQueryModal";
import LabelsQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/LabelsQueryModal";
import FolderQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/FolderQueryModal";
import IssuesQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/IssuesQueryModal";
import CaptionQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/CaptionQueryModal";
import UserTagsQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/UserTagsQueryModal";
import OutliersQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/OutliersQueryModal";
import MislabelsQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/MislabelsQueryModal";
import DuplicatesQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/DuplicatesQueryModal";
import UniquenessQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/UniquenessQueryModal";
import LabelOutliersQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/LabelOutliersQueryModal";
import CustomMetadataQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/CustomMetadataQueryModal";
import ObjectSizeQueryModal from "../DataPageFilters/ObjectSizeQueryModal";
import styles from "./style.module.scss";

export default function QueryModalWrapper() {
  const selectedQueryModalData = useSelector((state) =>
    getSelectedQueryModal(state)
  );
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const position = selectedQueryModalData?.position || null;
    if (modalRef.current && position) {
      modalRef.current.style.setProperty("--modal-top", `${position.top}px`);
      modalRef.current.style.setProperty("--modal-left", `${position.left}px`);
    }
  }, [selectedQueryModalData]);

  if (!selectedQueryModalData || !selectedQueryModalData.position) {
    return <noscript />;
  }

  const { type, id } = selectedQueryModalData;
  let modal;

  // Handle custom metadata types
  if (isCustomMetadata(type)) {
    modal = <CustomMetadataQueryModal editQueryId={id} />;
  } else {
    // Handle regular filter types using object map
    const modalMap = {
      [Filters.FILE]: <FileQueryModal editQueryId={id} />,
      [Filters.FOLDER]: <FolderQueryModal editQueryId={id} />,
      [Filters.LABELS]: <LabelsQueryModal editQueryId={id} />,
      [Filters.ISSUES]: <IssuesQueryModal editQueryId={id} />,
      [Filters.CAPTION]: <CaptionQueryModal editQueryId={id} />,
      [Filters.OUTLIERS]: <OutliersQueryModal editQueryId={id} />,
      [Filters.USER_TAGS]: <UserTagsQueryModal editQueryId={id} />,
      [Filters.MISLABELS]: <MislabelsQueryModal editQueryId={id} />,
      [Filters.DUPLICATES]: <DuplicatesQueryModal editQueryId={id} />,
      [Filters.UNIQUENESS]: <UniquenessQueryModal editQueryId={id} />,
      [Filters.LABEL_OUTLIER]: <LabelOutliersQueryModal editQueryId={id} />,
      [Filters.SIZE]: <ObjectSizeQueryModal editQueryId={id} />
    };

    modal = modalMap[type as Filters];
  }

  return (
    <div ref={modalRef} className={styles.modalPositioner}>
      {modal}
    </div>
  );
}
